module.exports = __webpack_public_path__ + "static/img/posture_souplesse_tronc.24678f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imageTests/posture_souplesse_tronc.png
// module id = rXgb
// module chunks = 1